import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import FlippWebBase = Generated.FlippWebBase
import BrowseContext = Generated.BrowseContext
import FlippWebBaseExtended = Generated.FlippWebBaseExtended
import Environment = Generated.Environment
import ClientParameters = Generated.ClientParameters
import AdAdaptedAdContext = Generated.AdAdaptedAdContext
import LocationSource = Generated.LocationSource

// Beacons
import BrowseAdAdaptedImpressionAd = Generated.BrowseAdAdaptedImpressionAd
import BrowseAdAdaptedOpenAddToCartAd = Generated.BrowseAdAdaptedOpenAddToCartAd
import BrowseAdAdaptedOpenAddToShoppingListAd = Generated.BrowseAdAdaptedOpenAddToShoppingListAd
import BrowseAdAdaptedViewableImpressionAd = Generated.BrowseAdAdaptedViewableImpressionAd

enum Schemas {
    BrowseAdAdaptedImpressionAdSchemaId = Generated.BrowseAdAdaptedImpressionAdSchemaId,
    BrowseAdAdaptedViewableImpressionAdSchemaId = Generated.BrowseAdAdaptedViewableImpressionAdSchemaId,
    BrowseAdAdaptedOpenAddToShoppingListAdSchemaId = Generated.BrowseAdAdaptedOpenAddToShoppingListAdSchemaId,
    BrowseAdAdaptedOpenAddToCartAdSchemaId = Generated.BrowseAdAdaptedOpenAddToCartAdSchemaId,
}

export {
    FlippWebBase,
    FlippWebBaseExtended,
    BrowseContext,
    AdAdaptedAdContext,
    BrowseAdAdaptedImpressionAd,
    BrowseAdAdaptedOpenAddToCartAd,
    BrowseAdAdaptedOpenAddToShoppingListAd,
    BrowseAdAdaptedViewableImpressionAd,
    Schemas,
    ClientParameters,
    LocationSource,
    Environment,
}
